import EventGameTiebreaker from "../EventGameTiebreaker";
import EventGameFixtures from "./EventGameFixtures";

export default class EventGamePredictionRequestBody {
  public fixtures: EventGameFixtures[] = [];
  public tiebreaker: EventGameTiebreaker | null;
}
